<template>
  <section class="ws-advanced-search">
    <ws-filter-item
            id="k"
            :type="filterType.SEARCH"
            :label="$t('Поиск по экспертам')"
            @ready="onFilterReady"
            @change="onFilter">
    </ws-filter-item>
    <header class="ws-advanced-search__header" @click="isOpen = !isOpen">
      <h3 class="ws-advanced-search__title has-text-primary is-size-2" v-text="title"></h3>
      <div class="ws-advanced-search__actions">
        <button class="ws-button button is-text"
                :aria-controls="id">
          <ws-icon
            class="ws-button__icon"
            name="arrow-thin"
            color="#000000"
            :class="{'ws-icon--left': !isOpen}"
            :fill="false"
            :title="$t('Свернуть/Развернуть')"
            width="17"
            height="11"
          />
        </button>
      </div>
    </header>
    <b-collapse
      :aria-id="id"
      class="ws-advanced-search__form"
      :open.sync="isOpen">
      <div class="columns">
        <div class="column is-3">
          <ws-permission-node :resources="['resources/region']" @permissions="setRegionPermission">
            <ws-filter-item
                    id="region_guid"
                    field="title.display"
                    :type="filterType.REFBOOK"
                    :label="$t('Регион')"
                    entity="public/refbook/region"
                    :params="{country: config.default_country_code}"
                    @ready="onFilterReady"
                    @change="onFilter">
            </ws-filter-item>
          </ws-permission-node>
        </div>
        <div class="column is-3">
          <ws-permission-node :resources="['resources/competency']">
            <ws-filter-item
                    id="competency_guid"
                    field="name.display"
                    :type="filterType.REFBOOK"
                    :label="$t('Профессия/специальность (ДЭ)')"
                    entity="competence"
                    @ready="onFilterReady"
                    @change="onFilter">
            </ws-filter-item>
          </ws-permission-node>
        </div>
        <div class="column is-3">
          <ws-filter-item
                  id="exam_day_cm1.from"
                  ref="exam_day_cm1.from"
                  :label="$t('Дата ПД (от)')"
                  :type="filterType.DATE"
                  @ready="onFilterReady"
                  @change="onFilter">
          </ws-filter-item>
        </div>
        <div class="column is-3">
          <ws-filter-item
                  id="exam_day_cm1.till"
                  ref="exam_day_cm1.till"
                  :label="$t('Дата ПД (до)')"
                  :type="filterType.DATE"
                  @ready="onFilterReady"
                  @change="onFilter">
          </ws-filter-item>
        </div>
      </div>
    </b-collapse>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import WsFilterItem from '@/components/common/WsFilterItem'
import filterMixin from '@/mixins/filter.mixin'
import filterType from '@/components/common/data/filter-type.enum'

export default {
  name: 'WsExpertsFilter',
  components: { WsFilterItem },
  mixins: [ filterMixin ],
  props: {
    id: {
      type: String
    },
    title: {
      type: String,
      default: 'Фильтры'
    }
  },
  data () {
    return {
      filterType,
      isOpen: true,
      keyword: '',
      config: __config
    }
  },
  computed: {
    ...mapGetters('profile', ['getUserSourcesPermission']),
    ...mapGetters('authentication', ['getUserGuid']),
    ...mapState('public/refbook/region', {
      isRegionPending: 'isFindPending'
    }),
    ...mapState('public/refbook/locality', {
      isLocalityPending: 'isFindPending'
    }),
    ...mapState('authentication', ['resourcesPermissions']),
    ...mapState('competence', {
      isCompetencePending: 'isFindPending'
    })
  },
  methods: {
    setRegionPermission (permission) {
      if (permission && permission.value) {
        this.region.isDisabled = true
      }
    }
  }
}
</script>
